import axios from 'axios'
import { MobileApiVariant, MobilePlatform, MobileVariant, UpdateType, type MobileVersionPolicy } from '@numeo/types'

export { MobileVariant, MobilePlatform, UpdateType }
export type { MobileVersionPolicy }

export type MobileVersionsConfig = {
    [V in MobileVariant]?: { [P in MobilePlatform]?: MobileVersionPolicy }
}

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

const VARIANT_TO_API_PARAM: Record<MobileVariant, MobileApiVariant> = {
    [MobileVariant.Dispatcher]: MobileApiVariant.Dispatcher,
    [MobileVariant.Driver]: MobileApiVariant.Driver,
}

export const mobileVersionPolicyApi = {
    getAll: async (): Promise<MobileVersionsConfig> => {
        const res = await axios.get<Envelope<{ mobileVersions: MobileVersionsConfig }>>('/gluon/config/mobile-versions')
        return res.data.data.mobileVersions ?? {}
    },

    setPolicy: async (variant: MobileVariant, platform: MobilePlatform, policy: MobileVersionPolicy): Promise<MobileVersionPolicy> => {
        const res = await axios.put<Envelope<{ variant: MobileVariant; platform: MobilePlatform; policy: MobileVersionPolicy }>>(
            '/gluon/config/mobile-versions',
            { variant, platform, policy }
        )
        return res.data.data.policy
    },

    clearPolicy: async (variant: MobileVariant, platform: MobilePlatform): Promise<void> => {
        await axios.delete<Envelope<{ variant: MobileVariant; platform: MobilePlatform }>>('/gluon/config/mobile-versions', {
            params: { variant, platform },
        })
    },

    // Live-tests the consumer endpoint to show what the mobile app would actually receive
    // for a given installed version. Useful as a "preview" inside the form so the editor
    // can see hard/soft/none transitions before publishing.
    preview: async (variant: MobileVariant, platform: MobilePlatform, currentVersion: string): Promise<{ updateType: UpdateType }> => {
        const variantParam = VARIANT_TO_API_PARAM[variant]
        const res = await axios.get<Envelope<{ updateType: UpdateType }>>(
            `/mobile-app/version-check?platform=${platform}&variant=${variantParam}&version=${encodeURIComponent(currentVersion)}`
        )
        return res.data.data
    },
}
